module.exports = __webpack_public_path__ + "static/media/approved-pay.01d0578d.svg";